import { useTranslation } from "react-i18next";
import { useRemoteMutation } from "../../useRemote/useRemoteMutation";
import { RemoteApiError } from "../../useRemote/types";
import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { ServiceDeliveryStatus } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { BookingServicesDto } from "../../../../features/Booking-Form/typings/booking.types";

export type UpdateServicesDto = {
  bookingId: string;
  bookingType: BookingType;
  deliveryStatus: ServiceDeliveryStatus;
  servicesInfo: BookingServicesDto[];
};

export function useRemoteUpdateBookingServicesByAdmin() {
  const { t } = useTranslation();

  return useRemoteMutation<void, RemoteApiError, UpdateServicesDto[]>({
    key: ["booking-service-update-booking-services"],
    url: "/booking-services/update-booking-services-by-admin",
    method: "put",
    snackbarTextOnFail: t(`There was a server error`)
  });
}
